export interface IOffer {
  id: number;
  additionalPhone: string;
  address: string;
  area?: number;
  availableFor: string[];
  availablePeriod: string;
  bedsCount?: number;
  bedsDescription: string;
  createdAt: string;
  facilities: string[];
  floor?: number;
  guestsCount: number;
  location: string;
  name: string;
  objectType: EObjectType;
  otherWishes: string;
  phone: string;
  priceDescription: string;
  priceType: EPriceType;
  roomsCount?: ERoomsCount;
  status: EStatus;
  comment: string;
  telegram: string;
}

export enum EStatus {
  New = 'new',
  Phone_not_available = 'phone_not_available',
  Canceled = 'canceled',
  Confirming = 'confirming',
  Busy = 'busy',
  Available = 'available',
}

export enum EObjectType {
  Bed = 'bed',
  Flat = 'flat',
  House = 'house',
  Room = 'room',
}

export enum EPriceType {
  Free = 'free',
  Symbolic = 'symbolic',
  Utility_bill = 'utility_bill',
}

export enum ERoomsCount {
  Five = 'five',
  Four = 'four',
  One = 'one',
  Six_and_more = 'six_and_more',
  Studio = 'studio',
  Three = 'three',
  Two = 'two',
}
